import firebase from 'firebase/app'
//import { determineGeoLocation } from 'lib/utils'
//import randomImage from 'lib/randomImage'
//import config from './config'
import _ from 'lib/lodash'
import axios from 'axios'
import jwt_decode from 'jwt-decode'

require("firebase/auth");
require("firebase/database");
require("firebase/storage");
// require("firebase/messaging");

let db = undefined;
let storage = undefined;
let auth = undefined;

// eslint-disable-next-line
//let userInfo = null;

const firebaseConfig = {
  "apiKey": process.env.REACT_APP_FIREBASE_APIKEY,
  "authDomain": process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  "databaseURL": process.env.REACT_APP_FIREBASE_DATABASEURL,
  "projectId": process.env.REACT_APP_FIREBASE_PROJECTID,
  "storageBucket": process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  "messagingSenderId": process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
};

export function initialize() {

	firebase.initializeApp(firebaseConfig);
	db = firebase.database();
	storage = firebase.storage().ref();
	auth = firebase.auth();

	/* get user's geolocation */
	/*if (config.determineGeoLocation) {
		determineGeoLocation().then((response) => userInfo = response);
	}*/
}

/* export functions */
/*export async function authenticateApp(tag) {
  // logout first
	if (auth.currentUser) await firebase.auth().signOut();

	const res = await fetch(`https://${firebaseConfig.authDomain}/api/getToken?tag=${tag}`);
	const ret = await res.json();

	console.log(res);

  return auth.signInWithCustomToken(ret.token).then(user => {
    // decode jwt token
    return user.getIdToken().then(jwt_decode);
  });
}
*/


/* export functions */
export async function signIn(tag) {
	// before signing in, check if user already signed in with current stickerId
	return axios.get(`https://${firebaseConfig.authDomain}/api/getToken`, { params: { tag } }).then(
		response => {
			const { status, data } = response;
			if (!data.token) return Promise.reject({ status, error: 'UNKNOWN_RESPONSE', message: data });

			// return decoded jwt token, logout first
			return signOut().then(() => auth.signInWithCustomToken(data.token).then(
				user => {
					//console.log(`Signed in with serialNo = '${auth.currentUser.uid}'`);
					return user.getIdToken().then(jwt_decode);
				}));
		},
		error => {
			const { status, data } = error.response;
			return data.error
				? Promise.reject({ status, error: data.error, message: data.message })
				: Promise.reject({ status, error: 'UNKNOWN_ERROR', message: data });
		}
	);
}


/* export functions */
/*export async function signIn(tag) {
	const token1 = (new Buffer('c3RpY2tlcnNAc2Vuc290aXguY29t', 'base64')).toString('utf8');
	const token2 = (new Buffer('cGFzc3dvcmRAc3RpY2tlcnNAc2Vuc290aXguY29t', 'base64')).toString('utf8');

	// return decoded jwt token, logout first
	return signOut().then(() => auth.signInWithEmailAndPassword(token1, token2).then(
		user => {
			return db.ref(`/tags/${tag}`).once('value').then(
				tagRef => {
					const val = tagRef.val();

					if (!val) return Promise.reject({error: 'INVALID_TAG', message: `Der eingegebene Webcode '${tag}' ist ungültig.`});

					const claims = {
						serialNo: `${val.serialNo}`,
						stickerId: val.stickerId,
						bundleId: val.bundleId,
						tagType: val.type
					};

					return claims;
				}
			);
		}
	));
}*/

export function signOut() {
	return signedIn() ? auth.signOut() : Promise.resolve();
}

export function signedIn() {
	return auth.currentUser;
}



/**
 *
 * TAG
 */

export async function fetchStickerSnapByTag(tag) {
	// sign in to access sticker resources
	return signIn(tag)
		.then(token => {
			//console.log(`Authenticated with uid = '${auth.currentUser.uid}'`);
			// return id portion of sticker (=stickerId and type) to proceed
			return db.ref(`/stickers/${token.stickerId}/type`).once('value').then(snapType => {
				return {
					tagId: tag,
					stickerId: token.stickerId,
					bundleId: token.bundleId,
					tagType: token.tagType
				};
			});
		});
}

/**
 *
 * STICKER
 */


export function fetchStickerById(stickerId, tagId) {
	return db.ref(`/stickers/${stickerId}`).once('value').then(snapSticker => {
		const stickerBranch = snapSticker.val();
		if (!stickerBranch) throw new Error(`Kein Eintrag für diesen Sticker gefunden`);

		return {
			sticker: createStickerContainer(stickerId, tagId, stickerBranch)
		}
	});
}

function createStickerContainer(stickerId, tagId, stickerBranch) {
	const sticker = {
		$id: stickerId,
		$tagId: tagId,
		$path: `/stickers/${stickerId}`,
		..._.omit(stickerBranch, ['tags'])
	};

	// organize all related payloads
	_.map(_.get(sticker, 'payloads'), (payloadType, keyPayloadType) => {
		_.map(payloadType, (payloadBranch, payloadId) => {
			sticker.payloads[keyPayloadType] = createStickerPayloadContainer(stickerId, keyPayloadType, payloadId, payloadBranch);
		})
	});

	return sticker;
}

function createStickerPayloadContainer(stickerId, payloadType, payloadId, payloadBranch) {
	const payload = {
		$id: payloadId,
		$stickerId: stickerId,
		$type: payloadType,
		$path: `/stickers/${stickerId}/payloads/${payloadType}/${payloadId}`,
		...payloadBranch,
	};

	_.map(payload.nodes, (nodeType, keyType) =>_.map(nodeType, (node, key) => {
		node.$id = key;
		node.$type = keyType;
		node.$payloadId = payloadId;
		node.$payloadType = payloadType;
		node.$stickerId = stickerId;

		const { $id, $type, $payloadId, $payloadType, $stickerId } = node;
		node.$path = `/stickers/${$stickerId}/payloads/${$payloadType}/${$payloadId}/nodes/${$type}/${$id}`;
	}));

	return payload;
}

/**
 *
 * BUNDLE
 */

export function fetchBundleById(bundleId) {
	return db.ref(`/bundles/${bundleId}`).once('value').then(snapBundle => {
		const bundleBranch = snapBundle.val();
		if (!bundleBranch) throw new Error(`Kein Eintrag für dieses Bundle gefunden`);

		return {
			bundle: createBundleContainer(bundleId, bundleBranch)
		}
	});
}

function createBundleContainer(bundleId, bundleBranch) {
	const bundle = {
		$id: bundleId,
		$path: `/bundles/${bundleId}`,
		..._.omit(bundleBranch, ['tags'])
	};

	// organize all related payloads
	_.map(_.get(bundle, 'payloads'), (payloadBranch, payloadId) => {
		bundle.payload = createBundlePayloadContainer(bundleId, payloadId, payloadBranch);
	});

	return _.omit(bundle, 'payloads');
}


function createBundlePayloadContainer(bundleId, payloadId, payloadBranch) {
	const payload = {
		$id: payloadId,
		$bundleId: bundleId,
		$path: `/bundles/${bundleId}/payloads/${payloadId}`,
		...payloadBranch,
	};

	_.map(payload.nodes, (nodeType, keyType) =>_.map(nodeType, (node, key) => {
		node.$id = key;
		node.$type = keyType;
		node.$payloadId = payloadId;
		node.$bundleId = bundleId;

		const { $id, $type, $payloadId, $bundleId } = node;
		node.$path = `/bundles/${$bundleId}/payloads/${$payloadId}/nodes/${$type}/${$id}`;
	}));

	return payload;
}

export function postNode(payload, node) {
	const nodePath = node.$path;
	const nodeBranch = _.omit(node, ['$path']);

	return db.ref(nodePath).push(nodeBranch).then(nodeRef => {
		return {
			$id: nodeRef.key,
			...node
		}
	});
}

export function postNodeAndFile(payload, node, file, onTick, onComplete, onError) {
	const payloadId = payload.$id;
	const { $type } = node;
	const payloadPath = payload.$path;
	const nodePath = node.$path;
	const nodeBranch = _.omit(node, ['$path', '$type']);

	return db.ref(nodePath).push(nodeBranch).then(nodeRef => {
		const nodeId = nodeRef.key;
		const storagePath = `/payloads/${payloadId}/nodes/${$type}/${nodeId}/${file.name}`;
		const newNodePath = `${nodePath}/${nodeId}`;

		const uploadTask = storage.child(storagePath).put(file, {
			customMetadata: {
				nodePath: newNodePath,
				payloadPath
			}
		});
		uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, onTick, onError, () => {
			// add storage info to node
			db.ref(`${newNodePath}/storage`).update({
				filePath: storagePath,
				fileUrl: uploadTask.snapshot.downloadURL,
				totalSize: uploadTask.snapshot.totalBytes
			}).then(() => onComplete(uploadTask.snapshot));
		});

		return {
			$id: nodeId,
			...node
		}
	});
}

export async function deleteNode(node) {
	// first, delete media file from storage, if available
	if (node.storage) {
		try {
			const { filePath } = node.storage;
			if (filePath) await storage.child(filePath).delete();
		} catch (e) {
			console.log(e);
		}

		// second, delete thumbnail file from storage
		try {
			const { thumbnailPath } = node.storage;
			if (thumbnailPath) await storage.child(thumbnailPath).delete();
		} catch (e) {
			console.log(e)
		}
	}

	// remove node from db
	return db.ref(node.$path).remove();
}

export function changeNodeProperty(node, property) {
	return db.ref(`${node.$path}/properties`).update(property);
}

let onStickerUpdateFirstTime = true; // update trigger also called initially, therefore ignore this event
export function onStickerUpdate(sticker, cb) {
	db.ref(sticker.$path).on('value', snapSticker => {
		if (onStickerUpdateFirstTime) {
			onStickerUpdateFirstTime = false;
		} else {
			cb(createStickerContainer(snapSticker.key, sticker.$tagId, snapSticker.val()));
		}
	});
}

let onBundleUpdateFirstTime = true; // update trigger also called initially, therefore ignore this event
export function onBundleUpdate(bundle, cb) {
	db.ref(bundle.$path).on('value', snapBundle => {
		if (onBundleUpdateFirstTime) {
			onBundleUpdateFirstTime = false;
		} else {
			cb(createBundleContainer(snapBundle.key, snapBundle.val()));
		}
	});
}

export async function sendEmail(params) {
	// before signing in, check if user already signed in with current stickerId
	return axios.get(`https://${firebaseConfig.authDomain}/api/sendEmail`, { params }).then(
		res => {
			const { data } = res;
			return !!data.error ? Promise.reject({error: data.error }) : Promise.resolve({response: data.response})
		},
		error => Promise.reject({ error })
	);
}

export const firebaseStorage = storage;

export const firebaseDatabase = db;

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
/*function deepDifference(object, base) {
	function changes(object, base) {
		return _.transform(object, function(result, value, key) {
			if (!_.isEqual(value, base[key])) {
				result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
			}
		});
	}
	return changes(object, base);
}*/


// WEBPACK FOOTER //
// ./src/db/firebase/index.jsx